import { Component, OnInit } from '@angular/core';
import {ConfirmationService, Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Traslado} from "./traslado";
import {TrasladoService} from "../Services/traslado.service";
import {ProductoService} from "../Services/producto.service";
import {Producto} from "../producto/producto";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {TrasladoDetalle} from "./trasladoDetalle";
import {InventarioService} from "../Services/inventario.service";
import {Inventario} from "../inventario/inventario";
import {UsuarioService} from "../Services/usuario.service";
import {Usuario} from "../usuario/Usuario";
import {ComboService} from "../Services/combo.service";
import {Combo} from "../combo/combo";

@Component({
  selector: 'app-traslado',
  templateUrl: './traslado.component.html',
  styleUrls: ['./traslado.component.css']
})
export class TrasladoComponent implements OnInit {


  msgs: Message[] = [];
  formTraslado : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  TrasladosRegistrados:Traslado[];
  TrasladoSeleccionado:Traslado;
  tipoGuardado = '';
  ProductosRegistrados:Inventario[];
  ProductosTraslado : Inventario[] = [];
  cantidad = '';
  TiendasRegistrados:Tienda[];
  DetalleTrasladosRegistrados:TrasladoDetalle[];
  verDetalleTraslado = false;
  lista = new Object();
  verPreTraslado = false;
  usuariosRegistrados:any[];
  CombosRegistrados:Combo[];



  constructor(private servicioCombo:ComboService,private servicioTienda:TiendaService,
              private servicioInventario:InventarioService,
              private servicioTraslado:TrasladoService,private fb: FormBuilder,
              private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.crearControlesTraslado();
    this.Cancelar();
    this.listarTiendas();
    this.listarTraslados();

  }

  crearControlesTraslado(){
    this.formTraslado = this.fb.group({
      tienda_origen_id:['',Validators.required],
      tienda_destino_id:['',Validators.required],
      responsable :[''],
      recibe :[''],
      }
    );

  }
  nuevoTraslado(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formTraslado.enable();
    this.formTraslado.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formTraslado.reset();
    this.formTraslado.disable();
    this.panelRequeridos = false;
    this.verDetalleTraslado = false;
    this.ProductosTraslado = [];
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  listarTraslados(){
    this.loading = true;
    this.servicioTraslado.getTraslado()
      .subscribe(
        rt => {
          this.TrasladosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  guardarNuevoTraslado(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioTraslado.putTraslado(this.formTraslado.value,this.TrasladoSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarTraslados();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      console.log(this.formTraslado.value);
      this.servicioTraslado.addTraslado(this.formTraslado.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarTraslados();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarDetalleTraslados(){
    this.loading = true;
    this.servicioTraslado.getDetallesByTraslado(this.TrasladoSeleccionado.id)
      .subscribe(
        rt => {
          this.DetalleTrasladosRegistrados = rt;
          if(rt.length != 0){
            this.verPreTraslado = false;
          }else {
            this.verPreTraslado = true;
          }

          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarTraslado(item:Traslado){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formTraslado.enable();
    this.panelRequeridos = true;
    this.TrasladoSeleccionado = item;
    this.listarUsuarios(item.tienda_destino_id);
    this.TrasladoDetalle(item);
    this.listarDetalleTraslados();
    this.listarProductos();
    this.listarCombos();
    this.verDetalleTraslado = true;
    this.tipoGuardado = 'editar';
  }
  TrasladoDetalle(item:Traslado):void {
   this.formTraslado.patchValue({
     id:item.id,
     tienda_origen_id:item.tienda_origen_id,
     tienda_destino_id:item.tienda_destino_id,
     responsable:item.responsable,
     recibe:item.recibe
   });
   }
  listarProductos(){
    this.loading = true;
    this.servicioInventario.getInventarioByTienda(this.TrasladoSeleccionado.tienda_origen_id)
      .subscribe(
        rt => {
          this.ProductosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  Mover(item:any){
    if( item.cant){
      let prod = [...this.ProductosTraslado];
      item['tipo'] = 'producto';
      item['cantTras'] = item.cant;
      item['traslado_id'] = this.TrasladoSeleccionado.id;
      item['producto_id'] = item.producto_id;
      item['nombre_producto'] = item.nombre;
      prod.push(item);
      this.ProductosTraslado = prod;
      this.verPreTraslado = true;
    }else {
      this.mensajes('warn','Atención','Antes de agregar un producto debe escribir una cantidad');
    }

  }
  MoverCombo(item:any){
    if( item.cantiCombo){
      let prod = [...this.ProductosTraslado];
      item['tipo'] = 'combo';
      item['cantTras'] = item.cantiCombo;
      item['traslado_id'] = this.TrasladoSeleccionado.id;
      item['producto_id'] = item.producto_id;
      item['nombre_producto'] = item.nombre;
      prod.push(item);
      this.ProductosTraslado = prod;
      this.verPreTraslado = true;
    }else {
      this.mensajes('warn','Atención','Antes de agregar un producto debe escribir una cantidad');
    }
  }
  BorrarProdTraslado(item:Producto){
    this.confirmationService.confirm({
      message: 'Esta seguro de quitar este item de la lista?',
      header: 'Atencion',
      icon: 'fa fa-trash',
      accept: () => {
        let prod = [...this.ProductosTraslado];
        let indice = prod.indexOf(item);
        prod.splice(indice,1);
        this.ProductosTraslado = prod;
      },
      reject: () => {
      }
    });

  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  generarTraslado(){
    let opcion = confirm('Esta seguro de de efectuar este traslado, esto no puede deshacerse');
    if(opcion){
      this.loading = true;
      let traslados = {productos:this.ProductosTraslado};
      this.servicioTraslado.addDetalleTraslado(traslados)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarDetalleTraslados();
            this.listarProductos();
            this.loading = false;
            this.verPreTraslado = false;
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {
          });
    }

}
  imprimirTraslado(){
    let url:string = 'https://api.appvinta.com/traslado/imprimir/'+ this.TrasladoSeleccionado.id;
    window.open(url,'blank');
  }
  listarUsuarios(id:number){
    this.loading = true;
    this.servicioTienda.getUsuariosByTienda(id)
      .subscribe(
        rt => {
          this.usuariosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });
  }
  listarCombos(){
    this.loading = true;
    this.servicioCombo.getComboByTienda(this.TrasladoSeleccionado['tienda_origen_id'])
      .subscribe(
        rt => {
          this.CombosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  ImprimirTraslado(item:Traslado){
    let url = 'https://api.appvinta.com/traslado/imprimir/'+item.id;
    window.open(url,'blank');
  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/traslado/traslado.component.ts